import { useTranslation } from "react-i18next";
import React from "react";
import { useForm, Controller } from "react-hook-form";

interface CheckoutFormProps {
  onSubmit: (data: any) => void;
}

const CheckoutForm: React.FC<CheckoutFormProps> = ({ onSubmit }) => {
  const { control, handleSubmit } = useForm();
  const { t } = useTranslation();
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label>{t("First Name")}</label>
        <Controller
          name="firstName"
          control={control}
          defaultValue=""
          render={({ field }) => <input {...field} className="input" />}
        />
      </div>
      <div>
        <label>{t("Last Name")}</label>
        <Controller
          name="lastName"
          control={control}
          defaultValue=""
          render={({ field }) => <input {...field} className="input" />}
        />
      </div>
      <button type="submit" className="btn-primary">
        {t("Submit")}
      </button>
    </form>
  );
};

export default CheckoutForm;
